import { Feature } from '@tencent/workbench';
import BaseToolbarFeature from '@src/framework/workbench/common/feature/base-toolbar-feature';
import { config } from './config';
import { IEditViewFeature } from './edit-view-interface';
import { EDIT_TYPE } from '@src/slide/domain/selection/constant/edit-type';

@Feature()
export class EditViewFeature extends BaseToolbarFeature implements IEditViewFeature {
    public id = config.id;
    public config = config;
    public constructor() {
        super();
    }

    public shouldCheck() {
        return this.isEditViewShow;
    }

    public onClick() {
        if (this.isEditViewShow) return;
        this.getAppService().editableServiceLayer
            ?.masterLayoutEditService?.changeEditType(EDIT_TYPE.SLIDE);
    }

    private get isEditViewShow(): boolean {
        const editType = this.getMasterLayoutEditService()?.editType;
        return !editType || editType === EDIT_TYPE.SLIDE;
    }
}
